/**
 * TanStack Query hooks for `multi-client-agency-support`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	multiClientAgencySupportQueryKeys,
	type CreateMultiClientAgencySupportBody,
	type ListMultiClientAgencySupportResponse,
	type MultiClientAgencySupportRow,
} from "./api";

export function useMultiClientAgencySupportList(): UseQueryResult<ListMultiClientAgencySupportResponse, Error> {
	return useQuery({
		queryKey: multiClientAgencySupportQueryKeys.list(),
		queryFn: list,
	});
}

export function useMultiClientAgencySupportCreate(): UseMutationResult<MultiClientAgencySupportRow, Error, CreateMultiClientAgencySupportBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: multiClientAgencySupportQueryKeys.all });
		},
	});
}

export function useMultiClientAgencySupportDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: multiClientAgencySupportQueryKeys.all });
		},
	});
}
